export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/ticket.ce8a36f8.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};